import {h} from "preact";
import s from "./defaultFallback.module.css";

const DefaultFallback = props => {
    // Destructured props
    const {
        onRetry,
        title = "Ops, algo deu errado por aqui.",
        message = "Ocorreu um erro inesperado ao exibir esta parte da página.",
        showHomeLink = true,
        compact = false
    } = props;

    return (
        <div className={`${s.container} ${compact ? s.compact : ""}`} role="alert">
            <h2 className={s.title}>
                {title}
            </h2>

            {message && (
                <p className={s.message}>
                    {message}
                </p>
            )}

            <div className={s.actions}>
                <button
                    type="button"
                    className={s.retryButton}
                    onClick={onRetry}
                >
                    Tentar novamente
                </button>

                {showHomeLink && (
                    // Plain anchor on purpose: a full reload after a crash
                    // restores the app from a clean state.
                    <a href="/" className={s.homeLink}>
                        Ir para a página inicial
                    </a>
                )}
            </div>
        </div>
    );
};

export default DefaultFallback;
